import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 呼叫记录统计
export function querycalllist (params, data) {
  params.token = getToken()
  return request({
    url: '/querycalllist',
    method: 'post',
    params,
    data
  })
}
// 搜索记录统计
export function searchcalllist (params, data) {
  params.token = getToken()
  return request({
    url: '/searchcalllist',
    method: 'post',
    params,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/callInfo.js